export default "__VITE_ASSET__CTKkZexa__"